var React = require('react');

function Javascript (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_10092_28817)","key":0},React.createElement("path",{"d":"M0 0L6.12647 67.4332L32.9485 75L59.9252 67.3816L66 0.0258089L0 0ZM30.5288 58.6822L11.1715 53.4574L11.1457 45.556L23.8876 49.0306L23.9647 14.4647H30.5288V58.6822ZM55.3432 32.4556L53.567 54.0495L35.7801 58.6822L35.6513 50.8579L48.5219 47.4346L48.702 41.0517L35.9343 43.2395L35.6513 14.5676L56.7848 14.4647L56.2184 22.3406L42.2154 22.3922V33.9228L55.3432 32.4556Z","fill":"white"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_10092_28817"},React.createElement("rect",{"width":"66","height":"75","fill":"white"})))]);
}

Javascript.defaultProps = {"width":"66","height":"75","viewBox":"0 0 66 75","fill":"none"};

module.exports = Javascript;

Javascript.default = Javascript;
